export const FETCH_AIS_VERSION_LIST = 'aisVersions/FETCH_AIS_VERSION_LIST';
export const FETCH_AIS_VERSION_LIST_SUCCESS = 'aisVersions/FETCH_AIS_VERSION_LIST_SUCCESS';
export const CHECK_AIS_VERSIONS = 'aisVersions/CHECK_AIS_VERSIONS';
export const EXPORT_AIS_VERSIONS = 'aisVersions/EXPORT_AIS_VERSIONS';
export const EXPORT_AIS_VERSIONS_SUCCESS = 'aisVersions/EXPORT_AIS_VERSIONS_SUCCESS';
export const EXPORT_AIS_VERSIONS_FAILURE = 'aisVersions/EXPORT_AIS_VERSIONS_FAILURE';
